import { amountFormatter, DashboardWalletSummary, HomeCard, shortLabelForWalletMacroCategoryList, walletPageMessages, walletCategoryMessages } from 'azshared';
import React, { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { AppDialog } from '../../../../../components/dialog/app-dialog';
import { AppProgressBar } from '../../../../../components/progress-bar/app-progress-bar';
import { AppSvgIcon } from '../../../../../components/svg-icon/app-svg-icon';
import { PirDeposit } from '../../../components/PirDeposit';
import './home-my-wallet-card.scss';

interface HomeMyWalletCardBarsProps {
  card: HomeCard<DashboardWalletSummary>;
  pirBoxDisclaimer: string;
}

export const HomeMyWalletCardBars = (props: HomeMyWalletCardBarsProps) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();
  const { card, pirBoxDisclaimer } = props;

  const handleModal = useCallback(() => {
    setOpenModal(!openModal);
  }, [openModal]);

  const filteredMacroCategories = useMemo(() => {
    if (!card.value?.macroCategories) return [];

    const hasRealEconomy = card.value.macroCategories.some(
      (cat) => cat.type === 'RealEconomy' && ((cat.amount && cat.amount.value > 0) || (cat.commitment?.value || 0) > 0)
    );

    const filtered = card.value.macroCategories.filter((macroCategory) => {
      // FIA spunta solo se c'è economia reale
      if (macroCategory.type === 'TotalFia') {
        return hasRealEconomy;
      }

      // TotalPortfolio spunta sempre, a prescindere dal valore
      if (macroCategory.type === 'TotalPortfolio') {
        return hasRealEconomy;
      }

      // Per le altre categorie, filtriamo per valore > 0
      return macroCategory.amount && macroCategory.amount.value > 0;
    });

    return filtered;
  }, [card.value?.macroCategories]);

  const hasTotalFia = useMemo(() => {
    return filteredMacroCategories?.some((cat) => cat.type === 'TotalFia');
  }, [filteredMacroCategories]);

  const getMacroCategoryLabel = useCallback(
    (type: string) => {
      if (type === 'TotalFia') {
        return formatMessage(walletPageMessages.walletPaymentNotValidated);
      }
      if (type === 'TotalPortfolio') {
        return formatMessage(hasTotalFia ? walletCategoryMessages.macrocategoryTotalPortfolio : walletCategoryMessages.macrocategoryTotalPortfolioNoAsterisk);
      }
      return formatMessage(shortLabelForWalletMacroCategoryList(type as any));
    },
    [formatMessage, hasTotalFia]
  );

  return (
    <div className='macrocategories-list'>
      {card.value?.macroCategories &&
        filteredMacroCategories.map((macroCategory, index) => (
          <div key={index} className='macrocategories-progress-bar'>
            <div className='amount-macrocategory'>
              <div className='amount-macrocategory-label'>{getMacroCategoryLabel(macroCategory.type)}</div>
              <div className={`amount-macrocategory-amount ${!card.value?.flagShowBalance ? 'blurry-text' : ''}`}>
                {amountFormatter(macroCategory.amount).split(' ', 2)[0]}{' '}
                <span className={`amount-symbol ${!card.value?.flagShowBalance ? 'blurry-text' : ''}`}>
                  {amountFormatter(macroCategory.amount).split(' ', 2)[1]}
                </span>
              </div>
            </div>
            {/* Mostra la barra solo se NON è totalFia o totalPortfolio */}
            {macroCategory.type !== 'TotalFia' && macroCategory.type !== 'TotalPortfolio' && (
              <AppProgressBar value={(macroCategory.percentage || 0) * 100} color={macroCategory.color ? macroCategory.color : '#C4C4C4'} />
            )}
          </div>
        ))}

      <>{pirBoxDisclaimer === 'MY_WALLET' && <PirDeposit />}</>

      {hasTotalFia && (
        <div className='fia-disclaimer'>
          <p className='fia-disclaimer-text'>{formatMessage(walletPageMessages.walletTotalFiaNote)}</p>
        </div>
      )}

      <AppDialog open={openModal} onClose={handleModal}>
        <div className='home-wallet-card-modal'>
          <div className='back-modal'>
            <AppSvgIcon icon='arrow-previous' onClick={handleModal} />
            <p>{formatMessage(walletPageMessages.walletBackTextModal)}</p>
          </div>
          <div className='modal-text'>{formatMessage(walletPageMessages.walletTotalModal)}</div>
        </div>
      </AppDialog>
    </div>
  );
};
